export const SupportLabel = {
  HrSupport: "HR Support",
  EmployeeName: "Employee Name",
  Issue: "Issue",
  DateOfRequest: "Date of Request",
  Completed: "Completed",
  OpenTickets: "Open Tickets",
  ClosedTickets: "Closed Tickets",
  Support: "Support",
  InProgressTickets: "In Progress Tickets",
  TotalTickets: "Total Tickets",
  Device: "Device",
  SupportRequest: "Support Request",
  HrSupportRequest: "HR Support Request",
  EmployeeSupport: "Employee Support",
  DeviceName: "Device Name",
  TypeOfIssue: "Type of Issue",
  ResourceNo: "Resource No",
  OnProcess: "On Process",
  InProgress: "In Progress",
  HrName: "HR Name",
  Title: "Title",
  Description: "Description",
  StartDate: "Start Date",
  EndDate: "End Date",
  DailyUpdate: "Daily Update",
  AddDailyUpdate: "Add Daily Update",
  EditDailyUpdate: "Edit Daily Update",
  DeviceIssue: "Device issue",
}

export const StatusConfirmation = (status, reason) => {
  return `Are you sure you want to ${status} the record with reason ${reason}?`;
};
